<div lOutsideClick (outsideClick)="close.emit()" class="bg-white rounded-xl shadow-lg p-4 w-48 relative">
  <ul class="space-y-3">
    @for (action of actions; track action.label) {
      <li
        [class.opacity-50]="action.disabled"
        [class.cursor-not-allowed]="action.disabled"
        [class.cursor-pointer]="!action.disabled"
        [class.hover:opacity-80]="!action.disabled"
        class="flex justify-between items-center"
        [ngClass]="action.colorClass"
        (click)="action.disabled ? $event.stopPropagation() : handleAction(action, $event)">
        <span>{{ action.label }}</span>
        <l-icon>{{ action.icon }}</l-icon>
      </li>
    }
  </ul>
  
  <p-confirmpopup />
</div>

